import allowlist from './allowlist/allowlist';
import siteInit from './siteInit/siteInit';
import extendedBreadcrumbs from './extendedBreadcrumbs/extendedBreadcrumbs';
import searchnav from './searchnav/searchnav';
import fallbackLayout from './fallbackLayout.ts';
import prevRoute from './prevRoute/prevRoute';

const reducers = {
  allowlist,
  siteInit,
  extendedBreadcrumbs,
  searchnav,
  fallbackLayout,
  prevRoute,
};

export default reducers;
